// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { NotificationSettingsApi } from '../types/notification-settings.types';
import { notificationSettingsHttpApi } from './notification-settings.api';
import { notificationSettingsMockApi } from './notification-settings.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const notificationSettingsApi: NotificationSettingsApi = useMock
  ? notificationSettingsMockApi
  : notificationSettingsHttpApi;
